import Cookies from "js-cookie";
import { listGroupsAdapter } from "../../adapters/get-list-groups.adapter";
import { ACCESS_TOKEN } from "../../util/constants/APP_RESERVED_NAME";
import { API_HEADER } from "../../util/constants/HEADERS";

export async function getGroupsByRole() {
    const user = JSON.parse(localStorage.getItem('asg_user') ?? '{}');

    if (user) {
        return await fetch(`${process.env.REACT_APP_API_URL}group/getListByRole/${user.role_id}`, {
            method: 'GET',
            headers: {
                ...API_HEADER,                
                Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
            },
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    return {
                        response: listGroupsAdapter(result.data)
                    }
                }
            })
            .catch(err => {
                return {
                    response: {
                        data: []
                    }
                }
            })
    }
}